const action = 'DATASOURCE_TRIGGER_JOB';
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

export const fetchRequest = (payload) => ({
  type: REQUEST,
  payload,
});

export const fetchSuccess = (payload) => ({
  type: RESPONSE,
  payload,
});

export const fetchFailure = (payload) => ({
  type: FAILURE,
  payload,
});

export const clear = () => ({
  type: CLEAR,
});
